import { Locale } from "@/enums/common.enum";
import { Property } from "@/interfaces/property.interface";
import { makePropertyLink } from "@/lib/property/helpers";
import clsx from "clsx";
import { useLocale } from "next-intl";
import { memo } from "react";
import { PropertyListViewProps } from ".";
import { PropertyViewCard } from "./PropertyViewCard";

interface PropertyListProps {
  id: string;
  properties: Array<Property>;
  variant?: PropertyListViewProps["variant"];
  onCardView: (property: Property, state: "on" | "off") => void;
  onCardClick: (property: Property, i: number) => void;
}

export const PropertyList = memo(
  ({ id, properties, variant, onCardClick, onCardView }: PropertyListProps) => {
    const locale = useLocale() as Locale;

    return (
      <ul className={clsx("flex flex-col gap-4 w-full overflow-hidden px-1")}>
        {properties
          .map((property: Property) => {
            property.photos = property?.photos?.filter(
              (photo) => photo?.length > 0
            );
            return property;
          })
          .filter((property: Property) => property.photos?.length > 2)
          .map((property: Property, i: number) => (
            <PropertyViewCard
              listingId={id!}
              onViewChange={onCardView}
              key={i}
              index={i}
              property={property}
              variant={variant}
              slotProps={{
                link: {
                  href: `${makePropertyLink(property, locale, id)}`,
                  onClick: () => onCardClick(property, i),
                  prefetch: true,
                },
              }}
            />
          ))}
      </ul>
    );
  }
);
PropertyList.displayName = "PropertyList";
